
import axios from 'axios'
import { url } from './url'


function getFaultReports(query) {
    var urlString = `${url}/detectionReports`;
    return axios
        .get(urlString, { params: query })
        .then(res => {
            return {
                total: res.data.data.total,
                faultReports: res.data.data.detectionReports.map(faultReport => {
                    return {
                        _id: faultReport.id,
                        createdAt: faultReport.createdAt,
                        customer: faultReport.customerName,
                        customerId: faultReport.customerId,
                        partner: faultReport.partner,
                        point: faultReport.point,
                        faultType: faultReport.detectionType,
                        severity: faultReport.severity,
                        pointPath: faultReport.pointPath,
                        info: faultReport.info,
                        evaluation: faultReport.evaluation,
                        image: faultReport.image
                    };
                })
            }
        });
}

function createFaultReport(data) {
    return axios.post(`${url}/fault-reports`, data)
        .then(resp => {
            return resp.data
        })
}
function deleteFaultReport(id) {
    return axios.delete(`${url}/detectionReports/${id}`)
        .then(resp => {
            return resp.data
        })
}

export default {
    getFaultReports,
    createFaultReport,
    deleteFaultReport
};